import { mount } from "@vue/test-utils";
import SelectOption from "@/components/core/custom/SelectOption";

describe("SelectOption component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(SelectOption);
  });

  it("Renders props.value when passed", () => {
    wrapper = mount(SelectOption);
    expect(wrapper.props()).toStrictEqual({
      label: undefined,
      value: undefined
    });
  });

  it("Renders props.value when passe name", () => {
    expect(wrapper.text()).toBe("");
  });

  it("Renders props.value when passe label", () => {
    expect(wrapper.props().label).toBeUndefined();
  });

  it("Renders props.value when passe value", () => {
    expect(wrapper.props().value).toBeUndefined();
  });
});
